import { render, staticRenderFns } from "./imgBase64.vue?vue&type=template&id=f10c07ea&scoped=true&"
import script from "./imgBase64.vue?vue&type=script&lang=ts&"
export * from "./imgBase64.vue?vue&type=script&lang=ts&"
import style0 from "./imgBase64.vue?vue&type=style&index=0&id=f10c07ea&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10c07ea",
  null
  
)

export default component.exports